import React, { Suspense } from "react";
import { UserData } from "../AppRoutes";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import MainPage from "../../pages/main-pages/MainPage";

interface ThirtyFthirtyRoutesProps {
  setIsAuthenticated: React.Dispatch<React.SetStateAction<UserData | null>>;
}

const Participants = React.lazy(
  () =>
    import("../../pages/main-pages/30-for-30/participants/list/ParticipantsList"),
);

const Events = React.lazy(
  () => import("../../pages/main-pages/30-for-30/events/list/EventList"),
);

const Challenges = React.lazy(
  () =>
    import("../../pages/main-pages/30-for-30/challenges/list/ChallengesList"),
);

const Notifications = React.lazy(
  () =>
    import("../../pages/main-pages/30-for-30/notifications/list/NotificationsList"),
);

const Winners = React.lazy(
  () => import("../../pages/main-pages/30-for-30/winners/Winners"),
);

const Sponsor = React.lazy(
  () => import("../../pages/main-pages/30-for-30/sponsor/list/SponsorList"),
);

const Team = React.lazy(
  () => import("../../pages/main-pages/30-for-30/team/list/TeamList"),
);

const Activity = React.lazy(
  () => import("../../pages/main-pages/30-for-30/activity/list/ActivityList"),
);

const ActivityLog = React.lazy(
  () => import("../../pages/main-pages/30-for-30/activity-log/ActivityLogForm"),
);

const Badges = React.lazy(
  () => import("../../pages/main-pages/30-for-30/badges/list/BadgesList"),
);

const AchievementBadges = React.lazy(
  () =>
    import(
      "../../pages/main-pages/30-for-30/achievement-badges/list/AchievementBadgesList"
    ),
);

const Reports = React.lazy(
  () => import("../../pages/main-pages/30-for-30/reports/Reports"),
);

const Master = React.lazy(
  () =>
    import("../../pages/main-pages/30-for-30/master/age-range/list/AgeRangeList"),
);

const ThirtyForThirtyRoutes: React.FC<ThirtyFthirtyRoutesProps> = ({
  setIsAuthenticated,
}) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route
          path="/"
          element={<MainPage setIsAuthenticated={setIsAuthenticated} />}
        >
          {/* Default redirect */}
          <Route index element={<Navigate to="participants" replace />} />

          {/* All sidebar routes */}
          <Route path="participants" element={<Participants />} />
          <Route path="event" element={<Events />} />
          <Route path="challenges" element={<Challenges />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="winners" element={<Winners />} />
          <Route path="sponsor" element={<Sponsor />} />
          <Route path="team" element={<Team />} />
          <Route path="school" element={<div>School Page</div>} />
          <Route path="activity" element={<Activity />} />
          <Route path="badges" element={<Badges />} />
          <Route
            path="achievement-badges"
            element={<AchievementBadges />}
          />
          <Route path="activity-log" element={<ActivityLog />} />
          <Route path="reports" element={<Reports />} />
          <Route path="master" element={<Master />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default ThirtyForThirtyRoutes;
